/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_HeadingInputs */

const zh_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让优质教育触手可及`)
};

const en_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Making Quality Education Accessible to All`)
};

const es_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haciendo la educación de calidad accesible para todos`)
};

/**
* | output |
* | --- |
* | "Making Quality Education Accessible to All" |
*
* @param {About_HeadingInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const about_heading = /** @type {((inputs?: About_HeadingInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_HeadingInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_about_heading(inputs)
	if (locale === "en") return en_about_heading(inputs)
	return es_about_heading(inputs)
});